import { useDeferredValue, useMemo, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { ShopTypes } from '~/lib/data-contract';
import isDateInRange from '~/shared/components/DatePicker/DatePickerRange/helpers/isDateInRange';

export function useStatementFilterData(
    data: ShopTypes.IAccountStatement[] | undefined,
    dateRange: (Date | null)[],
) {
    const [query, setQuery] = useState<string>('');

    const [debouncedQuery] = useDebounce(query, 200);

    const deferredValue = useDeferredValue(debouncedQuery);
    const processedData = useMemo(() => {
        return data?.map((item) => {
            const date = new Date(item.dateTimeOffset ?? '');
            const monthDate = date.toLocaleDateString('da-DK', { month: 'long' });

            const fullDate = [date.toLocaleDateString('en-GB').replace(/\//g, '-')].join(' ');

            return { ...item, monthDate, fullDate };
        });
    }, [data]);
    const filteredData = useMemo(() => {
        if (!processedData) return [];

        let filtered = processedData.filter((item) => {
            return (
                (!dateRange || isDateInRange(item.dateTimeOffset ?? item.fullDate, dateRange)) &&
                (item.fullDate.toLowerCase().includes(deferredValue.toLocaleLowerCase()) ||
                    item.monthDate.toLowerCase().includes(deferredValue.toLocaleLowerCase()))
            );
        });

        return filtered;
    }, [processedData, deferredValue, dateRange]);

    return {
        query,
        filteredData,
        setQuery,
    };
}
